import React from 'react';

import { USER_ROLES } from '../../utilities/constants';
import { SearchFormElement } from '../forms/SearchFormElement';
import {
  PartnerCompanyBranchDropdown,
  HEAD_OFFICE_OPTION,
} from '../PartnerCompanyBranchDropdown';

/**
 * 協力会社ユーザー検索フォーム
 * @params total {int} // 取得総数
 * @params isOpened {boolean} // 開閉フラグ
 * @params conditions {object} // 検索条件
 * @params callbacks {func} // イベントハンドラ
 */
export const PartnerUsersSearchForm = ({
  total,
  isOpened,
  conditions,
  callbacks,
  searchButtonRef,
  selectedCompanyId,
  partnerCompanyBranchId,
  handleSelectPartnerCompanyBranch,
  joiningFlag,
}) => (
  <div className='master-slide-view__searchform_no_border'>
    <div className='search-form'>
      <div className='search-form__header'>
        <div className='search-form__title'>
          検索条件（検索結果<span className='bold'>{total}</span>件)
        </div>
        <button
          id='accordion-toggle'
          className={isOpened ? 'accordion__btn show' : 'accordion__btn'}
          onClick={callbacks.handleOpen}
        />
        <button className='btn-text--sm' onClick={callbacks.clear}>
          検索条件クリア
        </button>
      </div>
      <div
        id='search-form-accordion'
        className={isOpened ? 'accordion show' : 'accordion'}
      >
        <div className='search-form__body'>
          <div className='form form--search-form'>
            <div className='form__group flex-wrap'>
              {!!joiningFlag && (
                <SearchFormElement
                  label='支店'
                  eleClass='form-element__element'
                >
                  <PartnerCompanyBranchDropdown
                    selectedCompanyId={selectedCompanyId}
                    selectedPartnerCompanyBranchId={partnerCompanyBranchId}
                    onSelect={handleSelectPartnerCompanyBranch}
                    isOptional={true}
                    fixedOptions={[HEAD_OFFICE_OPTION]}
                    dropdownSelectStyle={{ width: '190px' }}
                  />
                </SearchFormElement>
              )}

              <SearchFormElement label='種別' eleClass='element__item'>
                <div className='form-element__list'>
                  <label htmlFor='radio-user_role_code-1' className='radio'>
                    <input
                      id='radio-user_role_code-1'
                      name='user_role_code'
                      type='radio'
                      value={USER_ROLES.partner.id}
                      checked={
                        conditions.user_role_code == USER_ROLES.partner.id
                      }
                      onClick={callbacks.set}
                    />
                    <i className='i-2x' />
                    <span>管理者</span>
                  </label>
                  <label htmlFor='radio-user_role_code-2' className='radio'>
                    <input
                      id='radio-user_role_code-2'
                      name='user_role_code'
                      type='radio'
                      value={USER_ROLES.foreman.id}
                      checked={
                        conditions.user_role_code == USER_ROLES.foreman.id
                      }
                      onClick={callbacks.set}
                    />
                    <i className='i-2x' />
                    <span>職長</span>
                  </label>
                </div>
              </SearchFormElement>

              <SearchFormElement
                label='ユーザー名'
                eleClass='form-element__element'
              >
                <input
                  type='text'
                  name='fullname'
                  placeholder='ユーザー名を入力'
                  value={conditions.fullname}
                  onChange={callbacks.set}
                />
                <button
                  className='btn-fixedsize--stay search-form__btn'
                  onClick={callbacks.execution}
                  ref={searchButtonRef}
                >
                  検索
                </button>
              </SearchFormElement>
            </div>
            {!!joiningFlag && (
              <div className='search-form__info'>
                <div className='search-form__info-text'>
                  検索条件で支店を選択してユーザーが見つからない場合、支店を未選択にし氏名のみで再度検索してください。
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/searchmenus/PartnerUsers.jsx